// Retrieve Contracts
export const GET_CONTRACTS_START = "GET_CONTRACTS_START";
export const GET_CONTRACTS_SUCCESS = "GET_CONTRACTS_SUCCESS";
export const GET_CONTRACTS_FAILURE = "GET_CONTRACTS_FAILURE";

// Create User
export const CREATE_CONTRACT_START = 'CREATE_CONTRACT_START';
export const CREATE_CONTRACT_SUCCESS = 'CREATE_CONTRACT_SUCCESS';
export const CREATE_CONTRACT_FAILURE = 'CREATE_CONTRACT_FAILURE';

// Edit exiting User
export const EDIT_CONTRACT_START = 'EDIT_CONTRACT_START';
export const EDIT_CONTRACT_SUCCESS = 'EDIT_CONTRACT_SUCCESS';
export const EDIT_CONTRACT_FAILURE = 'EDIT_CONTRACT_FAILURE';

// Delete exiting User
export const DELETE_CONTRACT_START = 'DELETE_CONTRACT_START';
export const DELETE_CONTRACT_SUCCESS = 'DELETE_CONTRACT_SUCCESS';
export const DELETE_CONTRACT_FAILURE = 'DELETE_CONTRACT_FAILURE';


export const OPEN_FORM = "OPEN_FORM";
export const CLOSE_FORM = "CLOSE_FORM";